import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Popup from 'reactjs-popup'

import About from './About/About.jsx'

import geodatalogo from '../../images/group 7.png'
import infobutton from '../../images/infobutton.png'
import userprofile from '../../images/userprofile.png'
import SearchTinglystDokumentIcon from '../../images/hent_tinglyst_dokument.png'
import UtskriftBestillingIcon from '../../images/hent_bestillinger.png'
import MatrikkelSearchEvents from '../MatrikkelSearch/MatrikkelSearchEvents.js'

import './Header.scss'


class Header extends Component {
    state = {
        isContextMenuOpen: false,
        showAbout: false
    }

    onLogout = () => {
        this.props.onLogout()
    }

    onShowAbout = () => {
        this.setState({showAbout: true})
    }

    onSearchTinglystDokument = () => {
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowSearchTinglystDokument
        })
    }

    onShowUtskriftBestilling = () => {
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowUtskriftBestilling
        })
    }

    handleCloseAbout = () => {
        if (!this.state.showAbout) return
        this.setState({showAbout: false})
    }

    toggleContextMenu = (event) => {
        event.stopPropagation()
        this.setState({isContextMenuOpen: !this.state.isContextMenuOpen})
    }

    overlayStyle = {
        top: '50px',
        padding: '25px'
    }

    contentStyle = {
        border: '0',
        height: '100%',
        width: '80%',
        padding: '0'
    }

    render() {
        const { t } = this.props
        const name = this.props.settings ? this.props.settings.fullName : ""
        const customername = this.props.settings ? this.props.settings.customerName : ""
        const username = this.props.settings ? this.props.settings.username : ""        

        return (
            <div className="header">
                <img className="header-logo" src={geodatalogo} />
                <div className="header-title">
                    <span className="header-text">GEO</span><span className="header-text bold">EIENDOM</span>
                </div>
                <div className={`right-panel ${this.props.settings ? '' : 'hidden'}`}>
                { this.props.settings && this.props.settings.hasGrunnbokBestilling && this.props.settings.antallUtskriftBestillinger > 0 && <img className="icon tools" onClick={this.onShowUtskriftBestilling} title={t('bestilteutskrifter')} src={UtskriftBestillingIcon} /> }
                    { this.props.settings && this.props.settings.hasGrunnbok && <img className="icon tools" onClick={this.onSearchTinglystDokument} title={t('sokettertinglystdokument')} src={SearchTinglystDokumentIcon} /> }
                    <img className="icon" onClick={this.onShowAbout} title={t('logginn.omgeoeiendom')} src={infobutton} />
                    <div className={`userprofile header-context ${this.state.isContextMenuOpen ? 'open': ''}`}>
                        <img className="icon" title={t('logginn.brukerprofil')} onClick={this.toggleContextMenu} src={userprofile} />
                        {!this.props.isMobile &&
                            <div className="username">
                                {name}
                            </div>
                        }
                        { this.state.isContextMenuOpen &&
                            <div className="context-content">
                                <ul>
                                    <li>
                                        {this.props.isMobile &&
                                            <div>{name}</div>
                                        }
                                        <div>{t('logginn.brukernavn')}: {username}</div>
                                        <div>{t('logginn.firma')}: {customername}</div>
                                    </li>
                                    <li>
                                        <a className="logout" title={t('logginn.personvern')} href="https://www.geodata.no/artikkel/personvernerklaring" target="_blank">{t('logginn.personvern')}</a>                                       
                                    </li>
                                    <li>
                                        <span className="logout" onClick={this.onLogout}>{t('logginn.loggut')}</span>
                                    </li>                                    
                                </ul>
                            </div>
                        }
                    </div>
                    
                </div>
                <Popup contentStyle={this.contentStyle} overlayStyle={this.overlayStyle} open={this.state.showAbout} onClose={this.handleCloseAbout}>
                        <About token={this.props.token} settings={this.props.settings} onClose={this.handleCloseAbout} />
                </Popup>
            </div>
        )
    }
}

export default withTranslation('common')(Header)